import { useContext } from 'react';
import { AddressesContext } from '../contexts/addresses-context';
export const useAddresses = () => {
    const context = useContext(AddressesContext);
    if (!context) {
        throw new Error('useAddresses must be used within a AddressesProvider');
    }
    return context;
};
